<template>
  <span v-if="element && element.dateFieldValue">{{element.dateFieldValue.value | formatDate}}</span>
</template>

<script>
export default {
  name: "DateField",
  props: ["element", "entryItems"]
};
</script>